// Copyright 2021-2023 the Kubeapps contributors.
// SPDX-License-Identifier: Apache-2.0

import CustomAppView from "./CustomAppView";

export default CustomAppView;
